// import { useState } from "react";
// import axios from "axios";
// import { createPortal } from "react-dom";

// const FORGOT_API = "https://ecom.cyberathon.com/index.php/Api/forgot_password";

// function ForgotPassword({ show, onClose, openLogin }) {
//   const [formData, setFormData] = useState({
//     email: "",
//     new_password: "",
//     confirm_password: ""
//   });

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (formData.new_password !== formData.confirm_password) {
//       alert("Passwords do not match");
//       return;
//     }

//     try {
//       const res = await axios.post(FORGOT_API, formData);

//       if (res.data.status === "true") {
//         alert("Password updated successfully");
//         onClose();
//         openLogin(); // back to login
//       } else {
//         alert(res.data.message);
//       }
//     } catch (err) {
//       console.error(err);
//       alert("API Error");
//     }
//   };

//   if (!show) return null;

//   return createPortal(
//     <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
//       <div className="modal-dialog modal-dialog-centered">
//         <div className="modal-content p-3">

//           <h3 className="text-center">Forgot Password</h3>

//           <form onSubmit={handleSubmit}>
//             <input
//               type="email"
//               name="email"
//               placeholder="Enter Email"
//               className="form-control mb-2"
//               onChange={handleChange}
//               required
//             />

//             <input
//               type="password"
//               name="new_password"
//               placeholder="New Password"
//               className="form-control mb-2"
//               onChange={handleChange}
//               required
//             />

//             <input
//               type="password"
//               name="confirm_password"
//               placeholder="Confirm Password"
//               className="form-control mb-3"
//               onChange={handleChange}
//               required
//             />

//             <button className="btn btn-primary w-100">Submit</button>
//           </form>

//           <p
//             className="text-center mt-2 text-primary"
//             style={{ cursor: "pointer" }}
//             onClick={() => {
//               onClose();
//               openLogin();
//             }}
//           >
//             Back to Login
//           </p>

//         </div>
//       </div>
//     </div>,
//     document.body
//   );
// }

// export default ForgotPassword;


import { useState } from "react";
import axios from "axios";
import { createPortal } from "react-dom";

const FORGOT_API = "https://ecom.cyberathon.com/index.php/Api/forgot_password";

function ForgotPassword({ show, onClose, openLogin }) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [formData, setFormData] = useState({
    login: "",
    password: "",
    confirm_password: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirm_password) {
      alert("Passwords do not match");
      return;
    }
const isEmail = /\S+@\S+\.\S+/.test(formData.login);
const isPhone = /^[0-9]{10}$/.test(formData.login);

const payload = {
  password: formData.password,
  confirm_password: formData.confirm_password
};

if (isEmail) {
  payload.email = formData.login;
} else if (isPhone) {
  payload.phone = formData.login;
} else {
  alert("Enter valid email or 10 digit mobile number");
  return;
}
    try {
const res = await axios.post(FORGOT_API, payload, {
  headers: { "Content-Type": "application/json" }
});
      if (res.data.status === "true") {
        alert("Password updated successfully");
        onClose();
        openLogin();
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      console.error(err);
      alert("API Error");
    }
  };

  if (!show) return null;

  return createPortal(
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 20000
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          {/* HEADER (Same as Login) */}
          <div
            className="modal-header no-border d-flex flex-column align-items-center position-relative pt-0"
            style={{ borderBottom: "none" }}
          >
            <div className="w-100 d-flex justify-content-between align-items-center p-0">
              <h3 className="modal-title fw-bold text-center pt-0 text-dark fs-2">
                Forgot Password
              </h3>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
          </div>

          {/* BODY (Same spacing as Login) */}
          <div className="modal-body pt-0">
            <form onSubmit={handleSubmit}>

              {/* Email */}
              <div className="mb-3 pt-2">
                <label className="form-label">Email or Mobile Number</label>
                <input
                  type="text"
                  name="login"
                  className="form-control"
                  placeholder="Enter email or mobile number"
                  value={formData.login}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* New Password */}
              <div className="mb-3 position-relative">
                <label className="form-label">New Password</label>

                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="form-control pe-5"
                  placeholder="Enter new password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />

                <i
                  className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"}`}
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    top: "70%",
                    right: "15px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#3a3f43ff"
                  }}
                ></i>
              </div>

              {/* Confirm Password */}
              <div className="mb-3 position-relative">
                <label className="form-label">Confirm Password</label>

                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirm_password"
                  className="form-control pe-5"
                  placeholder="Confirm password"
                  value={formData.confirm_password}
                  onChange={handleChange}
                  required
                />

                <i
                  className={`bi ${showConfirmPassword ? "bi-eye" : "bi-eye-slash"}`}
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  style={{
                    position: "absolute",
                    top: "70%",
                    right: "15px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#3a3f43ff"
                  }}
                ></i>
              </div>

              {/* Submit Button SAME as login */}
              <button
                type="submit"
                className="bg-col fw-bold text-light border-0 mt-3 rounded-2 p-2 w-100"
              >
                Submit
              </button>

              {/* Back to login */}
              <div className="text-center pt-3 pb-1">
                <span>Remember password? </span>
                <span
                  className="text-primary text-decoration-underline"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    onClose();
                    openLogin();
                  }}
                >
                  Login
                </span>
              </div>

            </form>
          </div>

        </div>
      </div>
    </div>,
    document.body
  );
}

export default ForgotPassword;